import React from 'react';
import styled from 'styled-components';

type Size = 'small' | 'medium' | 'large';
interface Props {
   text: string;
   size: Size;
   margin?: string;
   overlay?: boolean;
}

const ToastAlert: React.FC<Props> = ({ text, size = 'small', margin, overlay = false }): JSX.Element =>
   overlay ? (
      <ToastDiv size={size} margin={margin}>
         {text}
      </ToastDiv>
   ) : (
      <ToastSpan size={size} margin={margin}>
         {text}
      </ToastSpan>
   );

export default ToastAlert;

const ToastDiv = styled.div<Omit<Props, 'text'>>`
   @keyframes fadeIn {
      from {
         opacity: 0;
      }

      to {
         opacity: 1;
      }
   }

   animation-timing-function: ease-in-out;
   transform-origin: bottom center;
   animation-name: fadeIn;
   background-color: ${({ theme }) => theme.secondaryGreen};
   text-align: center;
   padding: 20px 30px;
   border-radius: 5px;
   position: absolute;
   box-shadow: 0 14px 26px 0 rgba(0, 0, 0, 0.09);
   top: 50%;
   left: 50%;
   line-height: 1.5;
   font-weight: thin;
   transform: translate(-50%, -50%);
   max-width: 500px;
   width: 100%;
   z-index: 100;
   color: white;
   margin: ${({ margin = 0 }) => margin};
   animation-duration: 250ms;
   font-size: ${({ size }): string => {
      if (size === 'large') {
         return '24px';
      } else if (size === 'medium') {
         return '18px';
      } else {
         return '13px';
      }
   }};
   font-weight: 400;
`;

const ToastSpan = styled.span<Omit<Props, 'text'>>`
   @keyframes fadeIn {
      from {
         opacity: 0;
      }

      to {
         opacity: 1;
      }
   }

   animation-timing-function: ease-in-out;
   transform-origin: bottom center;
   animation-name: fadeIn;
   text-align: center;
   padding: 12px;
   z-index: 100;
   color: ${({ theme }) => theme.primaryBlueDark};
   animation-duration: 250ms;
   transition-duration: 250ms;
   padding-bottom: 5px;
   font-size: ${({ size }): string => {
      if (size === 'large') {
         return '24px';
      } else if (size === 'medium') {
         return '18px';
      } else {
         return '13px';
      }
   }};
   font-weight: bold;
`;
